import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { WEBSITE_PAGE_REGISTRY } from './websitePageConfig';

import HomePageComp from '../pages/HomePage';
import AboutPageComp from '../pages/AboutPage';
import FeaturesPageComp from '../pages/FeaturesPage';
import PricingPageComp from '../pages/PricingPage';
import SecurityPageComp from '../pages/SecurityPage';
import BlogPageComp from '../pages/BlogPage';
import NewsletterPageComp from '../pages/NewsletterPage';
import PressReleasePageComp from '../pages/PressReleasePage';
import PrivacyPolicyPageComp from '../pages/PrivacyPolicyPage';
import TermsConditionsPageComp from '../pages/TermsConditionsPage';
import RefundPoliciesPageComp from '../pages/RefundPoliciesPage';
import MigrationsPageComp from '../pages/MigrationsPage';
import DownloadPageComp from '../pages/DownloadPage';

// Helper to inject outlet context as props so page components get callbacks
function withOutletContext(Component) {
  const Wrapped = (props) => {
    const context = useOutletContext() || {};
    return <Component {...props} {...context} />;
  };
  Wrapped.displayName = `WithOutletContext(${Component.displayName || Component.name || 'Component'})`;
  return Wrapped;
}

/** Cloned Candor marketing pages (source: Candor-website-Updated-04062026). */
export const HomePage = withOutletContext(HomePageComp);
export const AboutPage = withOutletContext(AboutPageComp);
export const FeaturesPage = withOutletContext(FeaturesPageComp);
export const PricingPage = withOutletContext(PricingPageComp);
export const SecurityPage = withOutletContext(SecurityPageComp);
export const BlogPage = withOutletContext(BlogPageComp);
export const NewsletterPage = withOutletContext(NewsletterPageComp);
export const PressReleasePage = withOutletContext(PressReleasePageComp);
export const PrivacyPolicyPage = withOutletContext(PrivacyPolicyPageComp);
export const TermsConditionsPage = withOutletContext(TermsConditionsPageComp);
export const RefundPoliciesPage = withOutletContext(RefundPoliciesPageComp);
export const MigrationsPage = withOutletContext(MigrationsPageComp);
export const DownloadPage = withOutletContext(DownloadPageComp);

const pageById = {
  home: HomePage,
  about: AboutPage,
  features: FeaturesPage,
  pricing: PricingPage,
  security: SecurityPage,
  blog: BlogPage,
  newsletter: NewsletterPage,
  'press-release': PressReleasePage,
  'privacy-policy': PrivacyPolicyPage,
  'terms-conditions': TermsConditionsPage,
  'refund-policies': RefundPoliciesPage,
  'solutions-migrations': MigrationsPage,
  download: DownloadPage,
};

/** Nested routes under / (for WebsiteLayout + App.js). */
export const websiteNestedRoutes = WEBSITE_PAGE_REGISTRY.map((entry) => {
  const relativePath =
    entry.route === '/'
      ? ''
      : entry.route.replace(/^\/\/?/, '');
  return {
    path: relativePath,
    index: relativePath === '',
    Component: pageById[entry.id],
    id: entry.id,
  };
});
